export const ROLE_STYLIST = 1;
export const ROLE_SALON_ADMIN = 2;
export const ROLE_SYSTEM_ADMIN = 3;
export const ROLE_FRONT_DESK = 4;
export const ROLE_JDTECH_ADMIN = 6;
